import '../app/polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { isOneAppSearchParam, PUB_SUB_CHANNEL_APP } from '@wix/communities-blog-client-common';
import configureStore from '../app/store/configureStore';
import thunk from 'redux-thunk';

import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';

import createRequest from '../common/services/create-request-with-http-client';
import WidgetRoot from './containers/widget-root';
import { setConfig, getConfig } from '../app/services/config';
import { getInstance } from '../app/services/wix-sdk-utils';
import listenToSettingsChange from '../app/services/listen-to-settings-change';
import * as appLifecycleService from '../app/services/app-lifecycle-service';
import './styles/blog.scss';
import publishMiddleware from '../app/middleware/publish-middleware';
import subscribeMiddleware from '../app/middleware/subscribe-middleware';
import Wix from '../app/services/wix-sdk-polyfill';
import createShowMessage from '../app/services/create-show-message';

import modalMiddleware, { appModalResolvers, postEditorModalResolvers } from '../app/middleware/modal-middleware';
import createOneAppMiddleware from '../app/middleware/one-app-middleware';
import initUouBiMiddleware from './init-uou-bi-middleware';
import { setSiteInfo } from '../app/actions/set-site-info';
import { initClientI18n } from '../app/services/i18n-utils';

setConfig(window.__CONFIG__);

const baseUrl = window.__BASE_PATH__ || '';
const apiBaseUrl = window.__API_BASE_URL__ || '';
const instance = getInstance();
const instanceId = getConfig().instanceId;
const locale = window.__LOCALE__;
const request = createRequest({ apiBaseUrl, instance, instanceId, locale });
const requestFromSocialBlog = createRequest({ instance, instanceId, locale });

const browserHistory = useRouterHistory(createHistory)({ basename: baseUrl });

const i18n = initClientI18n();

const createMiddlewares = ({ appName, initialState, oneAppActionHandlers }) => [
  publishMiddleware(Wix.PubSub.publish),
  subscribeMiddleware(Wix.PubSub.subscribe, Wix.PubSub.unsubscribe, [PUB_SUB_CHANNEL_APP, appName]),
  createOneAppMiddleware({ origin: appName, i18n, actionHandlers: oneAppActionHandlers }),
  routerMiddleware(browserHistory),
  thunk.withExtraArgument({
    request,
    requestFromSocialBlog,
    baseUrl: baseUrl || `${window.location.protocol}//${window.location.host}`,
  }),
  modalMiddleware({
    createShowMessage,
    resolvers: {
      ...appModalResolvers,
      ...(isOneAppSearchParam(initialState) ? {} : postEditorModalResolvers),
    },
  }),
  initUouBiMiddleware(),
];

export default function initApp({ reducer, routes, appName, oneAppActionHandlers }) {
  const initialState = window.__INITIAL_STATE__ || {};
  const store = configureStore(
    initialState,
    createMiddlewares({ appName, initialState, oneAppActionHandlers }),
    reducer,
  );
  const history = syncHistoryWithStore(browserHistory, store);
  Wix.getSiteInfo((data) => store.dispatch(setSiteInfo(data)));

  listenToSettingsChange(store);
  appLifecycleService.appIsLoading();

  const renderFn = ReactDOM.hydrate || ReactDOM.render;
  renderFn(<WidgetRoot store={store} history={history} i18n={i18n} routes={routes} />, document.getElementById('root'));
}
